namespace advisorop.components.common {

    export class InvPerformanceOverviewController {

        public householdId: number;
        public performance: domains.IPerformanceOverview;
        
        static $inject = ["investorService", "generalService"];
        constructor(
            private invSrv: services.InvestorService,
            private gs: services.GeneralService) {
        }

        loadPerformanceOverview(householdId: number) {
            if (householdId) {
                this.invSrv.getPerformanceOverview(householdId)
                    .then(data => this.performance = data.data, err => this.gs.showError(err));
            } else {
                this.performance = null;
            }
        }
        
        $onInit(): void {
        }

        $onChanges(evt: any) {
            for (var key in evt) {
                if (key === "householdId") {
                    this.loadPerformanceOverview(this.householdId);
                }
            }
        }
        
    }
    
    class InvPerformanceOverview implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {      
                householdId: "<",
            };
            this.controller = InvPerformanceOverviewController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/investor-module/components/inv-performance-overview.html";
        }
    }
    angular.module(Constants.APP).component("invPerformanceOverview", new InvPerformanceOverview());

}